// Presence heartbeat — keeps "settlers online: N" fresh. Pings
// /api/presence every 45s while the tab is visible (plus immediately
// on boot / tab return) and pushes the returned count into every DOM
// node carrying the .settlers-online-count class, so screens don't
// need their own polling.

import { authHeader, getAccount } from './auth';

const HEARTBEAT_MS = 45_000;
const CID_KEY = 'settle:presence-cid';

let timer: number | null = null;
let lastCount: number | null = null;

function anonId(): string {
  try {
    let id = localStorage.getItem(CID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(CID_KEY, id);
    }
    return id;
  } catch {
    return 'ephemeral';
  }
}

export function onlineCount(): number | null {
  return lastCount;
}

function render(): void {
  const text = lastCount == null ? '' : `settlers online: ${lastCount}`;
  document.querySelectorAll<HTMLElement>('.settlers-online-count').forEach((n) => {
    n.textContent = text;
    n.classList.toggle('show', lastCount != null);
  });
}

async function beat(): Promise<void> {
  try {
    const res = await fetch('/api/presence', {
      method: 'POST',
      headers: { 'content-type': 'application/json', ...authHeader() },
      // cid is ignored server-side when signed in (account id wins).
      body: JSON.stringify(getAccount() ? {} : { cid: anonId() }),
    });
    if (!res.ok) { lastCount = null; render(); return; }
    const data = await res.json() as { ok?: boolean; online?: number };
    lastCount = data.ok && typeof data.online === 'number' ? data.online : null;
  } catch {
    lastCount = null;  // offline / vite dev — hide the line entirely
  }
  render();
}

/** Refresh any .settlers-online-count nodes that were just mounted. */
export function refreshPresenceDisplays(): void {
  render();
}

export function startPresence(): void {
  if (timer != null) return;
  void beat();
  timer = window.setInterval(() => {
    if (document.visibilityState === 'visible') void beat();
  }, HEARTBEAT_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void beat();
  });
}
